<template>
    <el-autocomplete v-model="supplierValue"
                      :disabled="disabled"
                      :fetch-suggestions="supplierSearch"
                      @select="selectItem"
                      @keyup.enter.native="enter"
                      @input="inputValue"
                      :value-key="itemName"
                      :placeholder="placeholder"
                      style="width: 240px"
                      ref="goods">
        <template slot-scope="{ item }">
            <div class="goods_search_item">
                <div class="code" v-html="brightenKeyword(item.code, supplierValue)"></div>
                <div class="name" v-html="`${$t('goods.alias')}：${brightenKeyword(item.name, supplierValue)}`" v-if="item.name"></div>
            </div>
        </template>
    </el-autocomplete>
</template>

<script>
    import AutoComplete from '../../../mixins/common/AutoComplete';
    import SearchObj from 'Components/common/search/SearchObj';

    export default {
        name: 'GoodsSearchAutoComplete',
        mixins: [AutoComplete],
        props: {
            placeholder: {
                type: String,
                default: '请选择产品'
            },
            goodsIdSearchObj: {
                type: Object,
                default: () => ({
                    param: 'id',
                    name: '产品编号'
                })
            },
            goodsNoSearchObj: {
                type: Object,
                default: () => ({
                    param: 'code',
                    name: '产品编号'
                })
            }
        },
        data() {
            return {
                url: '/base/info/product?unionCode=',
                itemName: 'code',
                currentItem: {}
            };
        },
        methods: {
            brightenKeyword(text, keywords) {
                let result = '';
                let isMatch = true;
                const normalizedKeywords = keywords.replace(/\s+/g, ' ').trim();
                const keywordArr = normalizedKeywords.split(' ');
                let str = text;
                keywordArr.forEach((item, index) => {
                    const str1 = str.toLowerCase();
                    const item1 = item.toLowerCase();
                    const i = str1.indexOf(item1);
                    if (i !== -1) {
                        const strL = str.slice(0, i);
                        const strK = str.slice(i, i + item.length);
                        const strR = str.slice(i + item.length);
                        result += strL;
                        result += `<span style="color: red">${strK}</span>`;
                        if (index === keywordArr.length - 1) {
                            result += strR
                        } else {
                            str = strR;
                        }
                    } else {
                        isMatch = false;
                    }
                });
                return isMatch ? result : text;
            },
            async supplierSearch(qs, cb) {
                if (qs && qs !== '' && qs.replace(/\s+/g, '').length >= 4) {
                    const { data } = await this.qGet(`${this.url}${qs}&pageSize=10&pageNum=0`);
                    cb(data && data.datas && data.datas.length > 0 ? data.datas : []);
                } else {
                    cb([]);
                }
            },
            async selectItem(item) {
                this.currentItem = item;
                if (item !== null) {
                    this.$emit('update:value', item[this.itemName]);
                    this.$emit('setTags', this.getGoodsIdSearchValue(item));
                    this.currentItem = {};
                }
            },
            enter() {
                this.$refs.goods.close();
                if (Object.keys(this.currentItem).length === 0) {
                    if (this.supplierValue.replace(/\s+/g, '').length >= 4) {
                        this.$emit('setTags', this.getGoodsSearchValue(this.supplierValue));
                    } else {
                        this.$message.error('请输入4个及以上字符！')
                    }
                }
                this.currentItem = {};
            },
            inputValue(e) {
                if (this.supplierValue.replace(/\s+/g, '').length >= 4) {
                    this.$refs.goods.activated = true;
                }
            },
            getGoodsIdSearchValue(item) {
                return new SearchObj(
                    this.goodsIdSearchObj.param, this.goodsIdSearchObj.name, item.id, 'autocomplete', item.code
                ).tags;
            },
            getGoodsSearchValue(item) {
                return new SearchObj(
                    this.goodsNoSearchObj.param, this.goodsNoSearchObj.name, item, 'autocomplete', item
                ).tags;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .goods_search_item {
        padding: 7px 0;
        .code {
            font-size: 14px;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: normal;
        }
        .name {
            font-size: 12px;
            color: #b4b4b4;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: normal;
        }
    }
</style>
